export default class CommandsController {
  #api;
  #paths;
  constructor(requestService, paths, persisttance) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async saveChildAvatarSelection({ childId, avatarId }) {
    try {
      const path = this.#paths.avatar.AvatarSelectionPath(childId);
      const { data } = await this.#api.Post(path, { avatar: avatarId });
      return data;
    } catch (error) {
      throw new Error('[Command]: We cant save your avatar.');
    }
  }

  async updateReward({ rewardId, body }) {
    try {
      const path = this.#paths.rewards.updateReward(rewardId);
      const { data: response } = await this.#api.Patch(path, body);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not update the reward...');
    }
  }

  async deleteReward({ rewardId }) {
    try {
      const path = this.#paths.rewards.updateReward(rewardId);
      const { data: response } = await this.#api.Delete(path);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not delete the reward...');
    }
  }

  async claimReward({ rewardId }) {
    try {
      const path = this.#paths.rewards.claimReward(rewardId);
      const { data: response } = await this.#api.Post(path);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not claim the reward...');
    }
  }

  async createReward({ rewardData }){
    try {
      const path = this.#paths.rewards.newReward;
      const { data: response } = await this.#api.Post(path, rewardData);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not create the reward...');
    }
  }

  async sendAnswersRate({ answersData }){
    try {
      const path = this.#paths.rate.rate;
      const { data: response } = await this.#api.Post(path, answersData);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not send answers of rate...');
    }
  }
  
  async updateCoinstValues({ childId, coinsToUpdate }){
    try {
      const path = this.#paths.coinsUpdater.saveCoinsValues(childId);
      const { data: response } = await this.#api.Post(path, coinsToUpdate);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not save coins values...');
    }
  }

  async acceptOrRejectCoins({ itemId, dataApproved }) {
    try {
      const path = this.#paths.coinsApproved.acceptOrRejectCoins(itemId);
      const { data } = await this.#api.Post(path, dataApproved);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I have not accept or reject the coins.');
    }
  } 
}

